import React from 'react';
import {Card} from "@material-ui/core";

export default function StyledCard({children, ...props}) {
    return <Card style={{border: '2px solid black', borderRadius: '8px', backgroundImage: 'linear-gradient(0deg, #333333,#212121)'}} variant="elevation" elevation={8} {...props}>
        {children}
    </Card>;
}